import { Types } from '../types/types';

export const arraySearch = (data: any[]) => ({
    type: Types.arraySearch,
    payload: data
});

export const valueSearched = (value: string) => ({
    type: Types.valueSearched,
    payload: value
});
